import { segment } from '@actions/analytics';
import {
  LOGIN_SIGN_UP_FIELD_CLICKED,
  SEGMENT_SIGNUP_FIELD_NAMES
} from '@cont/Login/constants';
import segmentStorage from '@events/segmentStorage';
import useLoginStore from '@stores/login/loginStore';
import { getIsRegistered } from '@stores/selectors/login';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { usePageInfo } from '@stores/AppCommonData';
import { LoginModalLocalInfo } from '@cont/Login/Context/LoginModalLocalInfo';
import useLoginExperimentEventProps from '@hooks/segment/useLoginExperimentEventProps';

const useSignUpStepsLogger = (source) => {
  const router = useRouter();
  const isRegistered = useLoginStore(getIsRegistered);
  const currentPageInfo = usePageInfo();
  const { handleOnFocus } = LoginModalLocalInfo() || {};
  const { name: currentScreen } = currentPageInfo;
  const experimentData = useLoginExperimentEventProps(source);
  return useCallback(
    (fieldName, state) => () => {
      if (typeof handleOnFocus === 'function')
        handleOnFocus({ fieldName, state });
      segment.track(LOGIN_SIGN_UP_FIELD_CLICKED, {
        ...(experimentData || {}),
        is_new_user:
          fieldName === SEGMENT_SIGNUP_FIELD_NAMES.PHONE_NUMBER
            ? 'NA'
            : !isRegistered,
        field_text: fieldName,
        current_screen: currentScreen || router.pathname,
        login_primary_source: segmentStorage.getItem('lps'),
        last_primary_source_section: segmentStorage.getItem('lpss') || 'NA',
        goal_name: router.query?.goalSlug,
        goal_uid: router.query?.goalUID,
        ...(state && { state })
      });
    },
    [router, isRegistered, currentScreen, handleOnFocus, experimentData]
  );
};

export default useSignUpStepsLogger;
